import { computed } from 'vue';
import { FAQ_URL } from '@/static/urls';
import DataTracker from '@/infrastructure/data-tracker';
import store from '@/store';

export default class HelpAndSupportBlockCode {

	private tracker = computed((): DataTracker => {
		return store.getters.tracker();
	});

	public navigateToHelpCentrePage(event: Event): void {
		event.preventDefault();
		this.tracker.value.trackHelpCentreClick();
		window.open(FAQ_URL, '_blank')?.focus();
	}

	public navigateToContactSupportPage(event: Event): void {
		event.preventDefault();
		this.tracker.value.trackContactSupportClick();

		const supportEmailAddress = 'consulting@studyportals.com';
		window.location.href = `mailto:${supportEmailAddress}`;
	}
}
